import React from "react";
import Skeleton from "../shared/skeleton-component";

const FetchNationalitySkeleton = () => {
  return (
    <>
      <Skeleton width="100%" height="50px" />
    </>
  );
};

export default FetchNationalitySkeleton;
